<ng-container *ngFor="let sectionTable of sectionData; let i = index">
    <table style="width: 100%">
        <ng-container *ngFor="let row of sectionTable">
            <ng-container *ngIf="row.rowType === 'TableHead'">
                <thead>
                    <tr
                        [style.color]="tableHeaderColor"
                        class="big-row-min-height_plus-border-height black-border-down header"
                    >
                        <th class="title text-align-bottom">
                            <div class="big-row-min-height_plus-border-height">{{ row.t }}</div>
                        </th>
                        <th
                            class="value text-align-bottom"
                            [style.background-color]="backgroundColor"
                        >
                            {{ row.cV }}
                        </th>
                        <th
                            class="value text-align-bottom fx-twin"
                            *ngIf="hasFxColumns(sectionTable)"
                            [style.background-color]="backgroundColor"
                        >
                            {{ row.cV2 }}
                        </th>
                        <th
                            class="value text-align-bottom"
                            *ngIf="!noPreviousData"
                            [style.background-color]="backgroundColorPY"
                        >
                            {{ row.pV }}
                        </th>
                        <th
                            class="value text-align-bottom fx-twin"
                            *ngIf="!noPreviousData && hasFxColumns(sectionTable)"
                            [style.background-color]="backgroundColorPY"
                        >
                            {{ row.pV2 }}
                        </th>
                    </tr>
                </thead>
            </ng-container>

            <ng-container *ngIf="row.rowType === 'Row'">
                <tr [style.color]="textColor" class="row-min-height_plus-border-height gray-border-down">
                    <td class="title text-align-top">{{ row.t }}</td>
                    <td class="value text-align-top" [style.background-color]="backgroundColor">{{ row.cV }}</td>
                    <td
                        class="value text-align-top fx-twin"
                        *ngIf="hasFxColumns(sectionTable)"
                        [style.background-color]="backgroundColor"
                    >
                        {{ row.cV2 }}
                    </td>
                    <td class="value text-align-top" *ngIf="!noPreviousData" [style.background-color]="backgroundColorPY">{{ row.pV }}</td>
                    <td
                        class="value text-align-top fx-twin"
                        *ngIf="!noPreviousData && hasFxColumns(sectionTable)"
                        [style.background-color]="backgroundColorPY"
                    >
                        {{ row.pV2 }}
                    </td>
                </tr>
            </ng-container>

            <ng-container *ngIf="row.rowType === 'GroupTotal' || row.rowType === 'TableTotal'">
                <tr
                    [style.color]="tableFooterColor"
                    class="row-min-height_plus-border-height big-row-min-height_plus-border-height ng-star-inserted"
                >
                    <td class="title row-min-height black-border-down bolder-bigger big-row-min-height text-align-top">
                        <span> {{ row.t }}</span>
                    </td>

                    <td
                        class="value black-border-down bolder-bigger big-row-min-height text-align-top"
                        [style.background-color]="backgroundColor"
                    >
                        {{ row.cV }}
                    </td>

                    <td
                        class="value black-border-down bolder-bigger big-row-min-height text-align-top fx-twin"
                        *ngIf="hasFxColumns(sectionTable)"
                        [style.background-color]="backgroundColor"
                    >
                        {{ row.cV2 }}
                    </td>

                    <td
                        class="value black-border-down bolder-bigger big-row-min-height text-align-top"
                        *ngIf="!noPreviousData"
                        [style.background-color]="backgroundColorPY"
                    >
                        {{ row.pV }}
                    </td>

                    <td
                        class="value black-border-down bolder-bigger big-row-min-height text-align-top fx-twin"
                        *ngIf="!noPreviousData && hasFxColumns(sectionTable)"
                        [style.background-color]="backgroundColorPY"
                    >
                        {{ row.pV2 }}
                    </td>
                </tr>
            </ng-container>
            <ng-container *ngIf="row.rowType === 'Footnote'">
                <tr [style.color]="textColor" class="row-min-height_plus-border-height footnote">
                    <td class="title text-align-top" [attr.colspan]="hasFxColumns(sectionTable) ? 5 : 3">{{ row.t }}</td>
                </tr>
            </ng-container>
        </ng-container>
    </table>
    <br />
</ng-container>
